import { render, staticRenderFns } from "./PasswordView.vue?vue&type=template&id=5201e64c&scoped=true&"
import script from "./PasswordView.vue?vue&type=script&lang=js&"
export * from "./PasswordView.vue?vue&type=script&lang=js&"
import style0 from "./PasswordView.vue?vue&type=style&index=0&id=5201e64c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201e64c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
